import MonitoringCard from "./monitoring";
import styles from "./styles.module.css";
import { Separator } from "../../ui/separator";

function MonitoringTimeView({ ccm, rpm }) {
  // Convert string values to boolean
  const isCcm = ccm === "true" || ccm === true;
  const isRpm = rpm === "true" || rpm === true;

  return (
    <section className={styles.monitoring_section}>
      {isCcm && <MonitoringCard noteType="ccm_note" />}
      {isRpm && isCcm && (
        <section className={styles.separator_section}>
          <Separator id="separator" orientation="vertical" height="300px" />
        </section>
      )}
      {isRpm && <MonitoringCard noteType="rpm_note" />}
    </section>
  );
}

export default MonitoringTimeView;
